"use client";

import { defaultLocale, type Locale } from "@/lib/i18n";
import AgentUseCasePage from "./AgentUseCasePage";
import { corporateComms } from "@/content/agent-use-cases/corporate-comms";

// Thin route wrapper — the catch-all maps a route to a component that takes only `locale`,
// so each available spoke gets a wrapper that binds its use-case data.
export default function CorporateCommsUseCase({
  locale = defaultLocale,
}: {
  locale?: Locale;
}) {
  return <AgentUseCasePage useCase={corporateComms} locale={locale} />;
}
